import React from 'react';
import { useTranslation } from 'react-i18next';

import { getIndustries, type IndustryDto } from '@/services/ws-selfbooking/src/main/resources/rest-api';
import { useSubscribe } from '@/js/libs/observable';
import { useRequest } from '@/js/libs/use-request';

import type { Option } from 'src/types';
import { formatIndustryOptionLabel } from '../helpers';

type UseIndustriesSelfBookingOptionsReturn = {
  options: Option<IndustryDto>[];
  pending: boolean;
};

type UseIndustriesSelfBookingOptions = () => UseIndustriesSelfBookingOptionsReturn;

export const useIndustriesSelfBookingOptions: UseIndustriesSelfBookingOptions = () => {
  const [, { language }] = useTranslation(['backend']);

  const getIndustriesRequest = useRequest({
    apiMethod: getIndustries,
    params: {},
  });

  const options = useSubscribe(
    getIndustriesRequest.data$,
    (response) =>
      response?.data.items.map((item) => ({
        label: formatIndustryOptionLabel(item, language),
        value: item,
      })) ?? [],
    [language],
  );
  const pending = useSubscribe(getIndustriesRequest.pending$);

  return React.useMemo<UseIndustriesSelfBookingOptionsReturn>(
    () => ({
      options,
      pending,
    }),
    [options, pending],
  );
};
